import React from "react";

function GradientMask() {
  return (
    <svg width="10000" height="200" style={{ outline: "1px solid red" }}>
      <defs>
        <linearGradient id="gradient" x2="0%" y2="100%">
          <stop offset="0" stopColor="white" stopOpacity="1" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>

        <mask id="gradient-mask">
          <rect x="0" y="0" width="10000" height="200" fill="url(#gradient)"  />
        </mask>
      </defs>
    </svg>
  );
}

function Masks() {
  return (
    <div className="masks">
      <GradientMask />
    </div>
  );
}

export default Masks;

